<template>
  <article ref="scrollBox" class="home bus_list_wrap CompareFlightIndex" style="height:100%;">
    <section class="pages_content">
      <swiper :swiperImgArray="advertList" :swiperWrapClass="swiperClass" :autoPlay="true" style="position:relative;z-index:1;"></swiper>
      <!-- <swiper></swiper> -->

      <div class="queryConditions" style="padding: 1rem 0.8rem;">
        <div class>
          <div class="inputDiv fontSize4 fontWeightChang" @click="chooseDepCity">
            <i style="color:#006535;" class="iconfont_new icon-dingwei3 inputIcon"></i>
            <span class="inputTitle">出发城市：</span>
            <div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">{{ depCity }}</div>
            <!-- <i-select v-model="arrCity" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
						<i-option v-for="item in getOnList" :key="item.ID" :value="item.ID">{{ item.PlaceName }}</i-option>
            </i-select>-->
          </div>
          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" @click="chooseArrCity">
            <i style="color:#006535;" class="iconfont_new icon-dingwei3 inputIcon"></i>
            <span class="inputTitle">到达城市：</span>
            <div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">{{ arrCity }}</div>
            <!-- <RadioGroup v-model="mudidi" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;" size="large">
						<Radio v-for="data in getOffList" :key="data.id" :label="data.PlaceName" :value="data.ID"></Radio>
            </RadioGroup>-->
          </div>
          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" @click="chooseAirCompany">
            <i style="color:#006535;" class="iconfont_new icon-feiji5 inputIcon"></i>
            <span class="inputTitle">航空公司：</span>
            <div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">{{ airCompanyName }}</div>
            <!-- <i-select v-model="airCompany" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
						<i-option v-for="item in airCompanyArray" :key="item.code" :value="item.code">{{ item.name }}</i-option>
            </i-select>-->
          </div>
          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" @click="chooseFlightType">
            <i style="color:#006535;" class="iconfont_new icon-dingwei3 inputIcon"></i>
            <span class="inputTitle">行程类型：</span>
            <div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">{{ flightType == 1 ? '单程' : '往返' }}</div>
            <!-- <i-select v-model="goBackIndex" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
          	<i-option v-for="item in goBackArray" :key="item.value" :value="item.value">{{ item.text }}</i-option>
            </i-select>-->
          </div>
          <!--          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" @click="chooseDepDate"> -->
          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang">
            <i style="color:#006535;" class="iconfont_new icon-rili inputIcon"></i>
            <span class="inputTitle">出发日期：</span>
            <DatePicker style="margin-left:108px;width:200px" type="date" :options="options1" placeholder="请输入出发日期"  @on-change="chooseDepDate"></DatePicker>
            <!-- <input v-model="depDate" placeholder="请输入出发日期" style="width: 100%;" type="date" readonly="true" /> -->
            <!--<div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
              {{ depDate }}
              <span v-if="depDate == today" class="colorprimary">（今天）</span>
              <span v-if="depDate == tomorrow" class="colorprimary">（明天）</span>
            </div> -->
          </div>
<!--          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" @click="chooseBackDate" v-if="flightType == 2"> -->
          <div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" v-if="flightType == 2">
            <i style="color:#006535;" class="iconfont_new icon-rili inputIcon"></i>
            <span class="inputTitle">返程日期：</span>
            <DatePicker style="margin-left:108px;width:200px" type="date" :options="options2" placeholder="请输入返程日期"  @on-change="chooseBackDate"></DatePicker>
            <!-- <input v-model="backDate" placeholder="请输入返程日期" style="width: 100%;" type="date" readonly="true" /> -->
<!--            <div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">{{ backDate }}</div> -->
          </div>

          <div class="flexContainer" style="margin-top:0.8rem;">
            <div class="flexItem1">
              <div class="queryConditionsButton textalignM" @click="getFlightList">搜 索</div>
            </div>
          </div>
        </div>
      </div>

      <!--      <div class="advertising">
        <div class="advertisingTitle colorprimary fontWeightCu">
          <i class="iconfont_new icon-rementuijian"></i> 活动推荐
        </div>
        <div class="textalignM" style="margin-bottom:0.1rem;">
          <img src="../assets/checpticketevent.jpg" width="100%" />
        </div>
        <div class="textalignM">
          <img src="../assets/pickup.jpg" width="100%" />
        </div>
      </div> -->

    </section>
  </article>
</template>

<script>
  import Swiper from "./child-components/Swiper";
  import scopeApi from "../request/scopeApi";
  import flightApi from "../request/flightApi";
  import {
    mapState
  } from "vuex";
  import baseTool from "../utils/baseFunction";
  import businessApi from '../request/businessApi';
  export default {
    name: "FlightQueryIndex",
    data() {
      return {
        name: "", // 商户标识
        advertList: [],
        swiperClass: "big_banner_wrap",

        today: baseTool.formatterDate(new Date()), //今天
        tomorrow: baseTool.formatterDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)), //明天

        //航司：
        airCompany: "",
        airCompanyArray: [{
            name: "全部",
            code: ""
          },
          {
            name: "南方航空",
            code: "CZ"
          },
          {
            name: "中国国航",
            code: "CA"
          },
          {
            name: "深圳航空",
            code: "ZH"
          },
          {
            name: "中国东方航空公司",
            code: "MU"
          },
        ], //航空公司列表

        //往返：
        goBackIndex: "true",
        goBackArray: [{
            text: "单程",
            value: true
          },
          {
            text: "往返",
            value: false
          },
        ],

        options1: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        options2: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now();
          }
        },

      };
    },
    components: {
      swiper: Swiper,
    },
    mounted() {
      this.getAdvertList();
    },
    activated() {
      if (this.$route.params.PlaceName && this.$route.params.PlaceName.length) {
        this.name = this.$route.params.PlaceName;
        this.getBusinessInfo();
      }
      this.setStoreData({
        selectedFlightList: [],
        selectedPolicyList: [],
        ifBackRefresh: true,
      }); // 每次进入此页都清空上次选择的航班与政策。
    },
    methods: {
      getBusinessInfo() {
        var that = this;
        //获取商户信息
        businessApi.getBusinessInfo(this.name).then(res => {
          if (res.success) {
            console.log(res.data)
          } else {
            this.$Modal.confirm({
              title: '服务提示',
              content: res.message,
              onOk: () => {
                that.name = 'zsairport';
                that.$router.replace({
                  name: 'FlightIndexPage',
                  params: {
                    page: 'scopeindex',
                    PlaceName: 'zsairport'
                  }
                });
              },
              onCancel: () => {
                that.name = 'zsairport';
                that.$router.replace({
                  name: 'FlightIndexPage',
                  params: {
                    page: 'scopeindex',
                    PlaceName: 'zsairport'
                  }
                });
              }
            });
          }
        });
      },
      setStoreData(updateObj) {
        this.$store.commit("flight/setFlightQueryCondition", updateObj);
      },
      chooseDepCity() {
        this.$router.push({
          name: "City",
          params: {
            mode: "dep",
          },
        });
      },
      chooseArrCity() {
        this.$router.push({
          name: "City",
          params: {
            mode: "arr",
          },
        });
      },
      chooseDepDate(date) {
        let that = this;

        // console.log(date)
        that.$store.commit("flight/setFlightQueryCondition", {
          depDate: date,
        });
        // this.$weui.datePicker({
        //   start: new Date(), // 从今天开始
        //   end: baseTool.addDate(new Date(), 60),
        //   onConfirm: (result) => {
        //     let tmpDate =
        //       result[0].value +
        //       "-" +
        //       (result[1].value < 10 ? "0" + result[1].value : result[1].value) +
        //       "-" +
        //       (result[2].value < 10 ? "0" + result[2].value : result[2].value);
        //     that.$store.commit("flight/setFlightQueryCondition", {
        //       depDate: tmpDate,
        //     });
        //   },
        // });
      },
      chooseAirCompany() {
        let that = this;
        let tmpArray = new Array();
        for (let i = 0; i < this.airCompanyArray.length; i++) {
          let tmp = {
            label: this.airCompanyArray[i].name,
            value: this.airCompanyArray[i].code,
          };
          tmpArray.push(tmp);
        }
        this.$weui.picker(tmpArray, {
          onConfirm(result) {
            that.$store.commit("flight/setFlightQueryCondition", {
              airCompanyName: result[0].label,
              airCompanyCode: result[0].value,
            });
          },
        });
      },
      chooseFlightType() {
        let that = this;
        let tmpArray = new Array();
        for (let i = 0; i < this.goBackArray.length; i++) {
          let tmp = {
            label: this.goBackArray[i].text,
            value: this.goBackArray[i].value,
          };
          tmpArray.push(tmp);
        }
        this.$weui.picker(tmpArray, {
          onConfirm(result) {
            that.$store.commit("flight/setFlightQueryCondition", {
              flightType: result[0].value ? 1 : 2,
            });
          },
        });
      },
      chooseBackDate(date) {
        let that = this;
        that.$store.commit("flight/setFlightQueryCondition", {
          backDate: date,
        });
        // this.$weui.datePicker({
        //   start: new Date(), // 从今天开始
        //   end: baseTool.addDate(new Date(), 60),
        //   onConfirm: (result) => {
        //     let tmpDate =
        //       result[0].value +
        //       "-" +
        //       (result[1].value < 10 ? "0" + result[1].value : result[1].value) +
        //       "-" +
        //       (result[2].value < 10 ? "0" + result[2].value : result[2].value);
        //     that.$store.commit("flight/setFlightQueryCondition", {
        //       backDate: tmpDate,
        //     });
        //   },
        // });
      },
      //获取轮播图列表：
      getAdvertList() {
        let that = this;
        this.advertList = [];
        // scopeApi.getAdvertInfoList(2).then((sucRes) => {
        //   if (sucRes.success) {
        //     for (let i = 0; i < sucRes.data.length; i++) {
        //       that.advertList.push(sucRes.data[i].GoodsLogoUrl);
        //     }
        //   }
        // });
        this.advertList.push(
          // "http://www.callmefix.net/api/Event/getImage?type=3&name=38",
          // "../assets/checpticketevent.jpg","../assets/pickup.jpg"
          "https://www.callmefix.net/img/checpticketevent.jpg",
          "https://www.callmefix.net/img/pickup.jpg",

        );
      },
      //确定：
      getFlightList() {
        if (this.depCity == "" || this.depCityPortCode == "") {
          alert("请选择出发机场城市！");
          this.chooseDepCity();
          return;
        }
        if (this.arrCity == "" || this.arrCityPortCode == "") {
          alert("请选择到达机场城市！");
          this.chooseArrCity();
          return;
        }
        if (this.flightType == 2 && this.depDate >= this.backDate) {
          alert("往返套票出发日期不得晚于返程日期。");
          this.chooseBackDate();
          return;
        }
        let that = this;
        this.$router.push({
          name: "FlightNoList",
          params: {
            name: that.name,
            IsGoBack:0
          }
        });
      },
    },
    computed: mapState({
      depDate: (state) => state.flight.depDate,
      backDate: (state) => state.flight.backDate,
      depCity: (state) => state.flight.depCity,
      depCityPortCode: (state) => state.flight.depCityPortCode,
      arrCity: (state) => state.flight.arrCity,
      arrCityPortCode: (state) => state.flight.arrCityPortCode,
      airCompanyCode: (state) => state.flight.airCompanyCode,
      airCompanyName: (state) => state.flight.airCompanyName,
      flightType: (state) => state.flight.flightType,
      psgType: (state) => state.flight.psgType,
      cabinRank: (state) => state.flight.cabinRank,
      directFlight: (state) => state.flight.directFlight,
      selectedFlightList: (state) => state.flight.selectedFlightList,
      selectedPolicyList: (state) => state.flight.selectedPolicyList,
      OpenId: (state) => state.user.OpenId,
    }),
  };
</script>

<style scoped lang="less">
  @import "../style/home.less";

  .queryConditions i {
    color: #006535;
  }
</style>



// WEBPACK FOOTER //
// src/components/FlightQueryIndex.vue